// src/hooks/useRemoteConfig.js
import { useState, useEffect } from "react";
import { initializeAndFetchConfig } from "../firebase/remote-config/remoteConfigService";

const useRemoteConfig = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const bootstrap = async () => {
      try {
        await initializeAndFetchConfig();
      } finally {
        setIsLoading(false);
      }
    };
    bootstrap();
  }, []);

  return { isLoading };
};

export default useRemoteConfig;
